import { Row, Col, Card } from 'antd'

import Map from './Map'
import Summary from './Summary'
import useModuleVehicle from '~/hooks/useModuleVehicle'
import HeadTitle from '~/components/HeadTitle'
import { FrameType } from '~/gql/generated/graphql'
import ModuleDetails from './Details'
import ModuleEvents from './Events'
import JourneysAndJobs from '~/components/Module/JourneysAndJobs'
import { getVehicleTitle } from '~/components/ModuleHeader'

type ModuleProps = {
  id: string
}

const Module = ({ id }: ModuleProps) => {
  const vehicle = useModuleVehicle(id)
  const scheme = vehicle?.detail?.scheme
  const assetTag = vehicle?.frame_id
  const isMaptexVehicle = [
    FrameType.okai_scooter,
    FrameType.segway_e_bike,
    FrameType.segway_e_bike_b200,
  ].includes(vehicle?.frame_type as FrameType)
  const title = getVehicleTitle(assetTag, vehicle?.frame_type as FrameType, id)

  return (
    <>
      <HeadTitle pageTitle={title} />
      <Row gutter={16} className="fill-height">
        <Col xs={24} lg={10} className="flex-col">
          <Summary id={id} />
        </Col>
        <Col xs={24} lg={14} style={{ minHeight: 500 }}>
          <Card
            id="module-map-card"
            bodyStyle={{
              padding: 0,
            }}
            style={{ containerType: 'size' }}
          >
            <div className="minimap-wrapper">
              <Map id={id} />
            </div>
          </Card>
        </Col>
        <Col md={24} xl={13}>
          <ModuleEvents
            id={id}
            isMaptexVehicle={isMaptexVehicle}
            lockConfig={vehicle?.detail.lock_configuration}
          />
        </Col>
        <Col md={24} xl={11}>
          <ModuleDetails id={id} isMaptexVehicle={isMaptexVehicle} />
        </Col>
        <Col xs={24} lg={24}>
          <JourneysAndJobs id={id} assetTag={assetTag} scheme={scheme} />
        </Col>
      </Row>
    </>
  )
}

export default Module
